import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import ExpiryChangePopup from "../../components/ExpiryChangeModal";
import {
  exportFromula,
  formatUnitsForReport,
  GetUpdatedDelivered,
} from "../../helpers/units";
import showNotification from "../../helpers/show_notification";
import { postSubmitForm } from "../../helpers/forms_helper";
import { findEarliestExpiringBatches } from "../../helpers/batchWithdrawl";
import moment from "moment";
import preloader from "../../helpers/preloader";
import { withNamespaces } from "react-i18next";
import BatchWithdrawModal from "../../components/BatchWithdrawModal";

const WithdrawModal = ({
  isOpen,
  toggle,
  transactionsModal,
  setTransactionsModal,
  selectedItem,
  transactions,
  isItem,
  t,
  handleViewDetailsClick,
  loadData,
}) => {
  const [selectedBatch, setSelectedBatch] = useState();
  const [withdrawModal, setWithrdrawModal] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const handleWithdrawClicked = async (quantity) => {
    if (quantity.length <= 0) {
      showNotification("Please select atleast one unit ", "Warning");
      return;
    }
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedItem.unit_levels
    );
    let WithdrawQuantity = convertedQuantity?.map((item) => ({
      unit: item.unit,
      value: Number(item.value),
    }));
    const isInvalidTransfer = WithdrawQuantity.some(
      (item) => item.value === 0 && item.isChecked
    );

    if (isInvalidTransfer) {
      showNotification(
        "Cannot withdraw products with 0 value and checked",
        "Warning"
      );
      return;
    }
    setIsLoading(true);
    let object = {
      quantity: WithdrawQuantity,
    };
    if (isItem) {
      object.branchiteminventory_id = selectedBatch._id;
    } else {
      object.branchproductinventory_id = selectedBatch._id;
    }

    let url =
      process.env.REACT_APP_BASEURL +
      `${
        isItem
          ? `branchiteminventories/withdraw`
          : `branchproductinventories/withdraw`
      }`;
    const response = await postSubmitForm(url, object);
    if (response && response.status === 1) {
      setIsLoading(false);
      showNotification(response.message, "Success");
       setTimeout(()=>{
          loadData();
        },1000)
      setTransactionsModal(!transactionsModal);
      setWithrdrawModal(!withdrawModal);
      return true;
    } else {
      setIsLoading(false);
      showNotification(response.message, "Error");
      return false;
    }
  };
  function checkValues(arr) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].value > 0) {
        return true;
      }
    }
    return false;
  }
  const [discardWasteModal, setDiscardWasteModal] = useState();
  const handleDiscardAsWaste = async (quantity) => {
    try {
      if (quantity.length <= 0) {
        showNotification("Please enter a valid quantity ", "Warning");
        return;
      }
      let convertedQuantity = GetUpdatedDelivered(
        quantity,
        selectedItem.unit_levels
      );
      const isInvalidTransfer = convertedQuantity.every(
        (item) => item.value == 0
      );
      if (isInvalidTransfer) {
        showNotification(
          "Cannot discard product with value 0 and checked",
          "Warning"
        );
        return;
      }
      const object = {
        quantity: convertedQuantity.map(({ unit, value }) => ({ unit, value })),
      };
      if (isItem) {
        object.inventory_id = selectedBatch._id;
      } else {
        object.branchproductinventory_id = selectedBatch._id;
        object.inventory_id = selectedBatch._id;
      }
      setIsLoading(true);
      let url =
        process.env.REACT_APP_BASEURL + `${isItem
          ?  `branchiteminventories/mark_wasted`
          : `branchproductinventories/mark_wasted`}`;
      const response = await postSubmitForm(url, object);
      if (response && response.status === 1) {
        showNotification(response.message, "Success");
        setTransactionsModal(!transactionsModal);
        setDiscardWasteModal(!discardWasteModal);
        setTimeout(()=>{
          loadData();
        },1000)
        setSelectedBatch();
        return true;
      } else {
        showNotification(response.message, "Error");
        return false;
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const [dateChangeModal, setDateChangeModal] = useState(false);
  const [selectedRowForDateChange, setSelectedRowForDateChange] =
    useState(null);
  const handleExpiryDateChange = async (newDate) => {
    try {
      if (!newDate) {
        showNotification("Please select a valid date", "Warning");
        return;
      }
      preloader(true);
      let url =
        process.env.REACT_APP_BASEURL + isItem
          ? "storeiteminventories/update_expiry_date"
          : "storeproductinventories/update_expiry_date";
      const payload = {
        id: selectedRowForDateChange._id,
        batch: selectedRowForDateChange.batch,
        expiry_date: moment(newDate).format("YYYY-MM-DD"),
      };
      const response = await postSubmitForm(url, payload);
      if (response && response.status === 1) {
        showNotification("Expiry date updated successfully", "Success");
         setTimeout(()=>{
           handleViewDetailsClick(selectedItem, {});
        },1000)
        setDateChangeModal(false);
        setSelectedRowForDateChange(null);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification("Error updating expiry date", "Error");
    } finally {
      preloader(false);
    }
  };
  const columns_item_transactions = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: t("Supplier"),
      dataField: "supplier_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "quantity",
      text: t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "selling_price",
      text: t("Selling Price"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: t("Expiry Date"),
      sort: false,
      formatter: (cell, row) => {
        if (row.expiry_date) {
          return moment(row.expiry_date).format("DD/MM/YYYY");
        } else {
          return (
            <>
              <span
                className="text-info d-flex align-items-center justify-content-center"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setSelectedRowForDateChange(row);
                  setDateChangeModal(true);
                }}
              >
                <i className="bx bxs-edit font-size-15" />
              </span>
            </>
          );
        }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "",
      text: t("Entry Date"),
      sort: false,
      formatter: (cell, row) => {
        return moment(row.createdAt).format("DD/MM/YYYY HH:mm");
      },
      headerStyle: (colum, colIndex) => {
        return { width: "16%" };
      },
    },
    {
      text: t("Withdraw"),
      formatter: (cell, row) => {
        // Finding earliest expiring batches
        const earliestBatches = findEarliestExpiringBatches(transactions || []);
        // Checking if current row is in earliest batches
        const isEarliestBatch = earliestBatches.some(
          (batch) => batch._id === row._id
        );
        // Check if the batch has quantity
        const hasQuantity = row.quantity.some((q) => q.value > 0);
        const isDisabled = row.expiry_date && !(isEarliestBatch && hasQuantity);
        return (
          <span className={`text-info ${isDisabled ? "text-muted" : ""}`}>
            <i
              className={`bx bx-download font-size-22 ${
                isDisabled ? "text-secondary" : ""
              }`}
              title="Withdraw"
              style={{
                cursor: isDisabled ? "not-allowed" : "pointer",
                opacity: isDisabled ? 0.5 : 1,
              }}
              onClick={() => {
                if (!isDisabled) {
                  setSelectedBatch(row);
                  setWithrdrawModal(!withdrawModal);
                }
              }}
            ></i>
          </span>
        );
      },
      hidden: selectedItem?.column === "waste",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: t("Mark Wasted"),
      formatter: (cell, row) => {
        return checkValues(row.quantity) ? (
          <span className="text-info">
            <i
              className="bx bxs-trash font-size-22"
              title="Move to Waste"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSelectedBatch(row);
                setDiscardWasteModal(!withdrawModal);
              }}
            ></i>
          </span>
        ) : (
          <span className="text-info">Out of stock</span>
        );
      },
      sort: false,
      hidden: selectedItem?.column !== "waste",
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
  ];
  const columns_product_transactions = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "quantity",
      text: t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "selling_price",
      text: t("Selling Price"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: t("Expiry Date"),
      sort: false,
      formatter: (cell, row) => {
        if (row.expiry_date) {
          return moment(row.expiry_date).format("DD/MM/YYYY HH:mm");
        } else {
          return (
            <>
              <span
                className="text-info d-flex align-items-center justify-content-center"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setSelectedRowForDateChange(row);
                  setDateChangeModal(true);
                }}
              >
                <i className="bx bxs-edit font-size-15" />
              </span>
            </>
          );
        }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: t("Withdraw"),
      formatter: (cell, row) => {
        // Finding earliest expiring batches
        const earliestBatches = findEarliestExpiringBatches(transactions || []);
        // Checking if current row is in earliest batches
        const isEarliestBatch = earliestBatches.some(
          (batch) => batch._id === row._id
        );
        // Check if the batch has quantity
        const hasQuantity = row.quantity.some((q) => q.value > 0);
        const isDisabled = row.expiry_date && !(isEarliestBatch && hasQuantity);
        return (
          <span className={`text-info ${isDisabled ? "text-muted" : ""}`}>
            <i
              className={`bx bx-download font-size-22 ${
                isDisabled ? "text-secondary" : ""
              }`}
              title="Withdraw"
              style={{
                cursor: isDisabled ? "not-allowed" : "pointer",
                opacity: isDisabled ? 0.5 : 1,
              }}
              onClick={() => {
                if (!isDisabled) {
                  setSelectedBatch(row);
                  setWithrdrawModal(!withdrawModal);
                }
              }}
            ></i>
          </span>
        );
      },
      sort: false,
      hidden: selectedItem?.column === "waste",
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: t("Mark Wasted"),
      formatter: (cell, row) => {
        return checkValues(row.quantity) ? (
          <span className="text-info">
            <i
              className="bx bxs-trash font-size-22"
              title="Move to Waste"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSelectedBatch(row);
                setDiscardWasteModal(!withdrawModal);
              }}
            ></i>
          </span>
        ) : (
          <span className="text-info">Out of stock</span>
        );
      },
      hidden: selectedItem?.column !== "waste",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "All",
        value: transactions && transactions.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
    hideSizePerPage: true,
    ignoreSinglePage: true,
  };

  return (
    <Modal size="xl" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <div>
          <div>{isItem? "Item Name : " : "Product Name : " }{selectedItem?.name}</div>
          {selectedItem?.unit_levels && (
            <div
              className="mt-2"
              style={{ fontSize: "0.9em", color: "#6c757d" }}
            >
              <span className="fw-bold">Formula:</span>{" "}
              {exportFromula(selectedItem.unit_levels)}
            </div>
          )}
        </div>
      </ModalHeader>
      <ModalBody>
        {selectedItem && (
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={12}>
                      <ToolkitProvider
                        keyField="_id"
                        data={transactions || []}
                        columns={
                          isItem
                            ? columns_item_transactions
                            : columns_product_transactions
                        }
                      >
                        {(props) => (
                          <div>
                            <BootstrapTable
                              {...props.baseProps}
                              pagination={paginationFactory(pagination_options)}
                              noDataIndication="No data to display."
                              striped
                              hover
                              condensed
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </ModalBody>
      {/* withdraw modal start  */}
      <BatchWithdrawModal
        isOpen={withdrawModal}
        toggle={() => {
          setWithrdrawModal(false);
          setSelectedBatch();
        }}
        onSubmit={handleWithdrawClicked}
        item={selectedItem}
        isLoading={isLoading}
        checkLimitFor={"batch"}
        selectedBatch={selectedBatch}
      />
      {/* withdraw modal end  */}

      {/* ---Waste Modal Start--- */}
      <BatchWithdrawModal
        isOpen={discardWasteModal}
        toggle={() => {
          setDiscardWasteModal(false);
          setSelectedBatch();
        }}
        onSubmit={handleDiscardAsWaste}
        item={selectedItem}
        isLoading={isLoading}
        checkLimitFor={"batch"}
        selectedBatch={selectedBatch}
      />

      {/* ---Waste Modal End--- */}
      {/* ---Expiry Date Modal Start--- */}
      <ExpiryChangePopup
        isOpen={dateChangeModal}
        toggle={() => {
          setDateChangeModal(false);
          setSelectedRowForDateChange(null);
        }}
        onSubmit={handleExpiryDateChange}
        initialDate={selectedRowForDateChange?.expiry_date}
        title="Change Expiry Date"
      />
      {/* ---Expiry Date Modal End--- */}
    </Modal>
  );
};

export default withNamespaces()(WithdrawModal);
